module.exports = __webpack_public_path__ + "static/media/md.3138a6d9.webp";